import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class IcebergBadge extends WritingBadge {
  public readonly id = BadgeId.iceberg;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.current >= 365 || stats.streakInfo.longest >= 365;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/iceberg.ts